import { MiMenu } from "@miplatform/components";
import { mdiFormatListBulleted } from "@mdi/js";
import { useTheme } from "@mui/material";

export const HoldsActionMenu = ({ onDetailsClick }) => {
  const theme = useTheme();
  return (
    <MiMenu
      data={[
        {
          label: "Details",
          icon: mdiFormatListBulleted,
          color: theme.palette.grey.main,
          action: onDetailsClick,
        },
      ]}
    />
  );
};
